import { Typography } from 'antd';
import styled from 'styled-components';
import { rem } from '../../utils/';
export const StyledEditableText = styled(Typography.Paragraph) `
  width: ${({ size }) => size && rem(size.width)};
  height: ${({ size }) => size && rem(size.height)};

  textarea {
    box-sizing: border-box;
    white-space: nowrap;
    resize: none;
    overflow: hidden;
    padding-top: ${({ size }) => size &&
    rem((size.height - size.fontSize) / 2 + 1)}; //To compensate border
    font-size: ${({ size }) => size && `${rem(size.fontSize)}`};
    border-color: ${({ theme }) => theme.Color.Brand.Primary} !important;
    caret-color: ${({ theme }) => theme.Color.Brand.Primary} !important;
    line-height: 1;
  }
`;
export const StyledInnerText = styled.div `
  display: flex;
  white-space: nowrap;
  overflow: hidden;
  font-size: ${({ size }) => size && `${rem(size.fontSize)}pt`};
  border-bottom: 1px dashed ${({ theme }) => theme.Color.Neutrals.Border};
  max-width: ${({ theme, size }) => size && rem(size.width - theme.Spacing.Size.Small)};
  height: ${({ size }) => size && rem(size.height)};
  align-items: center;
`;
export const StyledWrapper = styled.div `
  padding-left: ${({ theme }) => rem(theme.Spacing.Size.Small)};
`;
//# sourceMappingURL=EditableText.style.js.map